import { render, staticRenderFns } from "./RomaActivityList.vue?vue&type=template&id=3fb0cccf"
import script from "./RomaActivityList.vue?vue&type=script&lang=ts"
export * from "./RomaActivityList.vue?vue&type=script&lang=ts"
import style0 from "./RomaActivityList.vue?vue&type=style&index=0&id=3fb0cccf&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports